/**
 * 遊戲活動路由管理工具
 * 集中管理所有遊戲類型與對應的路由路徑
 */

/**
 * 遊戲類型與路由路徑的對應表
 * key: 遊戲類型代碼（來自 API 的 currentGame 欄位）
 * value: 對應的 Vue Router 路徑
 */
export const GAME_ROUTES = {
  'mol': '/ht-molegame-play',
  'mole': '/ht-molegame-play',
  'star': '/ht-pvpgame-play',
  'pvp': '/ht-pvpgame-play',
  'tf': '/ht-pvp-tfgame-play',
  'pick': '/ht-pickgame-play',
  'punch': '/ht-punchboard-play',
  'snake': '/ht-snakegame-play',
  'maze': '/ht-mazegame-play',
  'aigame': '/ht-aigame-play'
};

/**
 * 預設遊戲路由（當 currentGame 不在對應表中時使用）
 */
export const DEFAULT_GAME_ROUTE = '/ht-molegame-play';

/**
 * 檢查並重導向到正確的遊戲頁面
 *
 * @param {Object} activity - 活動資料（需包含 currentGame 欄位）
 * @param {string|string[]} currentPageGame - 當前頁面的遊戲類型
 *   - 單一字串: 'star' 表示此頁面只對應星星遊戲
 *   - 陣列: ['star', 'pvp'] 表示此頁面可接受多種遊戲類型（別名）
 * @param {Router} router - Vue Router 實例
 * @param {string} actId - 活動 ID
 * @param {boolean} switched - 是否已手動切換遊戲模式
 * @returns {boolean} 如果需要重導向則返回 true，否則返回 false
 *
 * @example
 * // 在 HTpvpGamePlay.vue 中使用
 * if (validateAndRedirectGame(activity, ['star', 'pvp'], router, actId, switched)) {
 *   return; // 已重導向，停止執行
 * }
 *
 * @example
 * // 在 HTMoleGamePlay.vue 中使用
 * if (validateAndRedirectGame(activity, ['mol', 'mole'], router, actId, switched)) {
 *   return;
 * }
 */
export function validateAndRedirectGame(activity, currentPageGame, router, actId, switched) {
  // 如果沒有 actId 或已手動切換，不進行驗證
  if (!actId || switched) {
    return false;
  }

  const currentGame = activity.currentGame;

  // 如果活動沒有設定 currentGame，不進行驗證
  if (!currentGame) {
    return false;
  }

  // 將 currentPageGame 轉換為陣列以支援別名
  const validGames = Array.isArray(currentPageGame) ? currentPageGame : [currentPageGame];

  // 檢查 currentGame 是否符合當前頁面
  if (!validGames.includes(currentGame)) {
    console.log('⚠️ currentGame 不符！活動設定為:', currentGame, '但目前在', validGames[0], '頁面');

    // 從對應表中找到目標路由
    const targetRoute = GAME_ROUTES[currentGame] || DEFAULT_GAME_ROUTE;

    console.log('🔀 重導向至:', targetRoute);

    // 執行重導向，保留 actId 參數
    router.replace({
      path: targetRoute,
      query: { actId }
    });

    return true;
  }

  // currentGame 符合，不需重導向
  return false;
}
